import React from 'react';
import { useSelector } from 'react-redux';
import { Select, Input, Form, Button } from 'antd';

import { getConfig, getToken } from '../redux/reducers/app';
import './style.css';

const { Option } = Select;
const { TextArea } = Input;

const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
};

const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 16,
    },
};

const Login = ({ startEce }) => {
    const token = useSelector(state => getToken(state));
    const appConfig = useSelector(state => getConfig(state));
    const cat=appConfig?.category;
    const categoryKeys = cat?Object.keys(appConfig.category):[];
    const categoryValues = cat?Object.values(appConfig.category):[];

    const onFinish = (values) => {
        const data = values;
        data.token = token;
        startEce(data);
    };

    return (
        <div style={{ height: '100%', position: 'relative' ,overflowY: 'scroll' }}>
            <div 
                style={{
                    margin: '44px 20px'
                }} 
            >
                <Form {...layout} name="nest-messages" onFinish={onFinish} validateMessages={validateMessages}>
                    <Form.Item
                        name="name"
                        label="Name"                       
                        rules={[{ required: true }]}
                    >
                        <Input maxLength='120'/>
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label="Email"                 
                        rules={[{ type: 'email', required: true }]}
                    >
                        <Input maxLength='50' />
                    </Form.Item>
                    <Form.Item
                        name="phone"
                        label="Phone"
                        rules={[{ required: false,  message: 'Please input your phone number!' }]}
                    >
                        <Input  maxLength='15' />
                    </Form.Item>
                    <Form.Item
                        name="category"
                        label="Category"
                        rules={[{ required: true }]}
                    >
                        <Select 
                            style={{ width: '100%' }}
                        >
                            {categoryValues.map((item, index) => (
                                <Option key={index} value={categoryKeys[index]}>{item}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="question"
                        label="Question"
                        rules={[{ required: true }]}
                    >
                        <TextArea rows={3} maxLength='200' autoSize={{ minRows: 2, maxRows: 3 }} />
                    </Form.Item>
                    <Button 
                        htmlType="submit" 
                        style={{ width: '100%' }}
                        className={'primary-color'}
                    >
                        Start Chat
                    </Button>
                 </Form>
            </div>
        </div>
    );
}

export default Login;